export const API_ROOT = (process.env.NODE_ENV === 'production')
  ? 'https://vdp2.skylarkdrones.com/'
  : 'https://vdp2.skylarkdrones.com/'; // http://192.168.0.104:8000

export const POSITION_TIME_DATA_SETTERS = Object.freeze({
  MAP: 'map',
  VIDEO: 'video',
  NAVBAR: 'navbar',
  POPUP: 'popup',
});

export const USER_ROLES = Object.freeze({
  USER: 'user',
  STAFF: 'staff',
  ADMIN: 'admin',
});
